import { DEMO, useDemo } from '../components/DemoModal';

// Expected CSV columns (header row):
// delivery_date, yard_city, yard_state, site_city, site_state, material, haul_fee, quantity
const TEMPLATE =
  'delivery_date,yard_city,yard_state,site_city,site_state,material,haul_fee,quantity\n' +
  '2026-05-01,Fayetteville,AR,Springdale,AR,hardwood_mulch,85,15';

export default function Import() {
  const { showDemo } = useDemo();

  return (
    <div className="page-wrap">
      <h2>Import delivery records</h2>
      <p className="muted">
        Upload a CSV of past deliveries. After import the freight curve is re-fit and pricing
        recomputed. Columns:
      </p>
      <pre className="card" style={{ padding: 12, overflow: 'auto', fontSize: 12 }}>
        {TEMPLATE}
      </pre>

      <div className="card" style={{ padding: 16, marginTop: 16 }}>
        <button className="btn" onClick={() => showDemo(DEMO.chooseFile)}>
          Choose File
        </button>
        <span className="muted" style={{ fontSize: 13, marginLeft: 10 }}>
          No file selected
        </span>
        <div>
          <button
            className="btn btn-primary"
            style={{ marginTop: 12 }}
            onClick={() => showDemo(DEMO.importRecords)}
          >
            Import records
          </button>
        </div>
      </div>
    </div>
  );
}
